import { Fragment } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Divider from 'src/components/ResumeCard/Divider';
import translation from 'src/components/translation';
import type { ResumeCardData } from 'src/models/resumeCard';

import CollapseCollection from 'src/components/ResumeCard/Body/Collapse/Collection';
import Field from 'src/components/ResumeCard/Body/Field';

const TrlKeys = {
    title: 'resumeCard.field.education',
};

const Education: TranslatedComponent<{ resume: ResumeCardData }> = ({ resume, trls }) => {
    const educations = resume.primaryEducation;
    if (!educations?.length) {
        return null;
    }
    return (
        <Field title={trls[TrlKeys.title]} dataQaName="education">
            <CollapseCollection
                collection={educations}
                renderItem={(education, index) => (
                    <Fragment key={education.id}>
                        {index !== 0 && <VSpacing default={8} />}
                        <div key={education.id} data-qa="resume-serp_resume-item-content">
                            {education.name}
                            <Divider />
                            {education.year}
                        </div>
                    </Fragment>
                )}
                dataQa="education"
            />
        </Field>
    );
};

export default translation(Education);
